export const REQUIRED_RULE = 'Field is required'
export const NUMBER_RULE = 'Value has to be a number'
export const INTEGER_RULE = 'Value cannot be a decimal'
export const PHONE_NUMBER_RULE = 'Please enter a valid phone number'
export const EMAIL_VALIDATION_REQUIRED_RULE = 'Email is required.'
export const EMAIL_VALIDATION_FORMAT_RULE = 'Incorrect email format.'
export const PASSWORD_VALIDATION_REQUIRED_RULE = 'Password is required.'
export const CONFIRM_PASSWORD_VALIDATION_REQUIRED_RULE = 'Confirm password is required.'
export const EQUAL_PASSWORD_VALIDATION_RULE = 'Passwords do not match'

export const CONTACT_NUMBER_FORMAT_RULE = 'Incorrect contact format.'
export const TRAILERNAME_VALIDATION_REQUIRED_RULE = 'Trailer name is required'
export const FARMNAME_VALIDATION_REQUIRED_RULE = 'Farm name is required'
export const ADDRESS_VALIDATION_REQUIRED_RULE = 'Address is required'
export const BUSINESS_TITLE_VALIDATION_REQUIRED_RULE = 'Customer name is required'
export const CUSTOMER_CODE_VALIDATION_REQUIRED_RULE = 'Customer code is required'
export const CONTACT_NAME_VALIDATION_REQUIRED_RULE = 'Contact name is required'
export const EMPLOYEE_NAME_VALIDATION_REQUIRED_RULE = 'Employee name is required'
export const ROLE_REQUIRED_RULE = 'Role is required'
export const CATEGORY_REQUIRED_RULE = 'Category is required'
export const URL_VALIDATION_FORMAT_RULE = 'Invalid format of location url.'
export const FIELD_REFERENCE_VALIDATION_REQUIRED_RULE = 'Field reference is required.'
export const FARM_VALIDATION_REQUIRED_RULE = 'Farm is required.'
export const VEHICLE_NAME_VALIDATION_REQUIRED_RULE = 'Vehicle name is required.'
export const REGISTRATION_VALIDATION_REQUIRED_RULE = 'VRM is required.'
export const PRODUCT_NAME_VALIDATION_REQUIRED_RULE = 'Product name is required.'
export const ANALYSIS_DATE_VALIDATION_REQUIRED_RULE = 'Analysis date is required.'
export const PRODUCT_TYPE_VALIDATION_REQUIRED_RULE = 'Product type is required.'
export const SILO_NAME_VALIDATION_REQUIRED_RULE = 'Silo name is required.'
export const SERVICE_NAME_REQUIRED_RULE = 'Waste collection service name is required'
export const SERVICE_CODE_REQUIRED_RULE = 'Waste collection service code is required'
export const SERVICE_COLLECTION_SITE_REQUIRED_RULE = 'Waste collection site is required'
export const SERVICE_DELIVERY_SITE_REQUIRED_RULE = 'AD plant site is required'
export const SERVICE_WASTE_DELIVERY_SITE_REQUIRED_RULE = 'Waste delivery site is required'
export const DELIVERYSITE_NAME_REQUIRED_RULE = 'AD plant site name is required'
export const WASTE_DELIVERYSITE_NAME_REQUIRED_RULE = 'Waste delivery site name is required'
export const COLLECTIONSITE_NAME_REQUIRED_RULE = 'Waste collection site name is required'
export const WASTE_NAME_REQUIRED_RULE = 'Waste name is required'
export const TIMESHEET_DATE_REQUIRED_RULE = 'Date is required'
export const TIMESHEET_EMPLOYEE_REQUIRED_RULE = 'Employee name is required'
export const CUSTOMER_REQUIRED_RULE = 'Customer name is required'
export const AT_LEAST_ONE_FIELD_REQUIRED_RULE = 'At least one field is required'
export const ADSITE_REQUIRED_RULE = 'AD plant site is required'
export const TIMESHEET_DATE_CANNOT_BE_FUTURE = 'Future date cannot be selected.'
export const TIME_REQUIRED = 'Time is required.'

export const VOLUME_LEFT_EXCEED_ERROR = 'Volume left cannot exceed the total volume of the silo.'
export const TOTAL_TONNAGE_EXCEED_ERROR =
  '(The total tonnage of the product to be used on fields exceeds the volume left in the silo)*'
export const FAILED_TO_EXPORT = 'failed to export'
export const FAILED_TO_UPDATE = 'failed to update'
export const COLLECTION_SITE_UNAVAILABLE = 'No waste collection site to archive'
export const DELIVERY_SITE_UNAVAILABLE = 'No AD Plant site to archive'
export const WASTE_DELIVERY_SITE_UNAVAILABLE = 'No Waste Delivery site to archive'
export const EMPLOYEE_UNAVAILABLE = 'No Employee to archive'
export const FARMS_UNAVAILABLE = 'No Farms to archive'
export const FIELDS_UNAVAILABLE = 'No Field to archive'
export const JOBS_UNAVAILABLE = 'No Job to archive'
export const PRODUCT_UNAVAILABLE = 'No Product to archive'
export const SERVICE_UNAVAILABLE_TO_DELETE = 'No Service to archive'
export const SILOS_UNAVAILABLE = 'No Silos to archive'
export const TIMESHEETS_UNAVAILABLE = 'No Timesheet to archive'
export const TRAILERS_UNAVAILABLE = 'No Trailers to archive'
export const VEHICLES_UNAVAILABLE = 'No Vehicles to archive'
export const CUSTOMER_UNAVAILABLE = 'No Customers to archive'
export const START_AND_END_TIME_FIRST = 'Select main start and end times first.'
export const BREAK_START_TIME_WITHIN_ERROR = 'Break start must be within start and end times.'
export const BREAK_END_TIME_WITHIN_ERROR = 'Break end must be within start and end times.'
export const BREAK_END_BEFORE_BREAK_START_ERROR = 'Break end cannot be before break start.'
export const END_TIME_AFTER_START_ERROR = 'End time must be after start time.'
export const EXCEED_PRODUCT_QUANTITY_ERROR =
  'The quantity of product being added exceeds the total volume capacity of the silo.'

export const RESET_PASSWORD_REQUEST_SUCCESS = 'Password reset request sent successfully'
export const JOB_STATUS_CHANGED = 'The status of the job has been changed. Click here to refresh.'
export const JOB_UPDATED = 'The job has been updated. Click here to refresh.'
export const JOB_EDIT_UPDATED =
  'The job has been updated. Please click the refresh button to load the latest changes.'
export const JOB_DELETE_UPDATED = 'This job has been deleted by another user.'
export const JOB_START_ASSIGNEE_CONFIRM_MESSAGE = 'You will be assigned to this job If you start.'

export const DOWNLOAD_AND_FIX_MESSAGE =
  'Please download the file to fix the issues and re-upload the file.'
export const DOWNLOAD_FILE_MESSAGE = 'Please download the file to view errors.'
export const NO_SILOS_FOUND_IN_FARM = 'No silos found in the selected farm.'
export const NO_LOCATIONS_FOUND_IN_FARM = 'No locations found in the selected farm.'
export const NO_FIELD_IN_FARM_ERROR =
  '(Please select a field in the chosen farm to create this job.)*'
export const PASSWORD_REQUIREMENTS = [
  'At least 8 characters',
  'At least 1 uppercase letter',
  'At least 1 lowercase letter',
  'At least 1 number',
  'At least 1 special character'
]